
import { Navigate } from "react-router";
import { useEffect, type JSX } from "react";
import { useForm } from "react-hook-form"
import { FloatingInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useAddPagesMutation } from "../../stores/OkOkStore";
import type { ResponseError } from "../../types/CommonReponse";

import { useTrads } from "../../contexts/trads/useTrads";
import type { PagesInsert } from "../../types/Pages";
import TinyMceEditor from "../Common/TinyMceEditor";

export function  PagesInsertForm (): JSX.Element {
    const  pages:PagesInsert={titre:"",texte:""};
    const [addPages,result]=useAddPagesMutation();
    const { register, handleSubmit,setError,setValue,control, formState: { errors } } = useForm({
        defaultValues:pages,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate,setLoaded}=useTrads();
    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
        if(result.isSuccess){
            setLoaded(false);
        }
    },[setError,result,translate,setLoaded]);
    
    return (
        result.isSuccess ? <Navigate to={`/pages/${result.data.id.toString()}`} state={{"modified":true}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <form className="row" onSubmit={(event) => void handleSubmit(addPages)(event)}>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="name"
                    label={translate('page_titre')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("titre", {
                        required: translate("page_error_titre_requis"),
                        minLength: 2
                    })} 
                />

            </div>
            <div className="col-12  mb-3">
                <p>{translate('page_texte')}</p>
                <TinyMceEditor 
                    control={control}
                    name="texte"
                    onChange={(data) => {setValue('texte',data,{shouldValidate:true});}}
                />
            </div>
            

            <div className="col-4  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    )
};

export default PagesInsertForm;

